var $ = require('./../sw-jquery');

$(document).ready(function() {

  $('body').on('click', '[data-sw-clipping-tool]', function() {
    if(!$(this).hasClass('disabled')) {
      var $vizIFrames = $('[data-sw-3d-tools-viz-iframe]');

      for(var i = 0; i < $vizIFrames.length; i++) {
        var iFrame = $vizIFrames[i];
        var remote = iFrame.getAttribute('src');
        iFrame.contentWindow.postMessage('clipTool', remote);
      }
    }
  });
});
